/* Copyright 2013 - 2024 Waiterio LLC */
import getSentryBrowser from './getSentryBrowser.js'

export default function captureExceptionBrowser(error) {
  const sentry = getSentryBrowser()

  if (sentry?.captureException) {
    sentry.captureException(error)
  }

  // Also report to PostHog, so Error Tracking sees these. posthog-js autocapture
  // only sees *uncaught* errors, and every caller of this function is an
  // ErrorBoundary — which swallows the error before it reaches window.onerror.
  // Without this, React render crashes are invisible in PostHog. No
  // double-reporting for the same reason: autocapture never saw them.
  //
  // PostHog is injected asynchronously by GTM and is absent on some surfaces, so
  // both the object and the method are optional. This runs inside
  // componentDidCatch, where throwing would mask the original error — hence the
  // belt-and-braces try/catch around a call that should already be safe.
  if (typeof window !== 'undefined') {
    try {
      window.posthog?.captureException?.(error)
    } catch {
      // DO NOTHING ON PURPOSE
    }
  }
}
